import { Vehicle } from '@esportal/portal-service';

export enum VehicleNotificationType {
	Mantenimiento = 'mantenimiento',
	PreITV = 'pre-itv',
}

export interface VehicleNotification {
	// id: string;
	vehicle: Vehicle;
	notificationType: VehicleNotificationType;
	// date: Date;
}
